module.exports = "https://www.gc-qa.gnp.com.mx/50019d7498045550b0a08a2847288961.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-informativo.svg
// module id = 8124
// module chunks = 0